import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bb35d14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6bb35d14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb35d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb35d14')) {
      api.createRecord('6bb35d14', component.options)
    } else {
      api.reload('6bb35d14', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bb35d14&scoped=true", function () {
      api.rerender('6bb35d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MDinput/index.vue"
export default component.exports